const field = (key, label, type = "text", extra = {}) => ({ key, label, type, ...extra });
const name = field("name", "Name", "text", { maxLength: 120 });
const status = field("status", "Status", "select", { options: ["active", "inactive"] });
const employee = field("employee_id", "Employee", "reference", { resource: "employees" });
const reason = field("reason", "Reason / audit note", "textarea", { maxLength: 500 });
const attendance = field("status", "Attendance status", "select", { options: ["present", "absent", "half_day"] });
const note = field("note", "Note", "textarea", { optional: true, maxLength: 500 });
export const resourceFields = {
  employees: [field("employee_code", "Employee code", "text", { maxLength: 40, pattern: "[A-Za-z0-9][A-Za-z0-9._\\/\\-]{0,39}" }), name,
    field("joining_date", "Joining date", "date"), status,
    field("department_id", "Department", "reference", { resource: "departments", optional: true }),
    field("designation_id", "Designation", "reference", { resource: "designations", optional: true }),
    field("user_id", "Linked organisation user", "reference", { resource: "users", optional: true })],
  designations: [name, status],
  attendance: [employee, field("date", "Attendance date", "date"), attendance, note],
  leaves: [employee, field("leave_type", "Leave type", "text", { maxLength: 80, placeholder: "e.g. Casual, sick, unpaid" }), field("start_date", "Start date", "date"), field("end_date", "End date", "date"), reason],
  holidays: [name, field("date", "Holiday date", "date"), status],
  assets: [field("asset_code", "Asset code", "text", { maxLength: 40, pattern: "[A-Za-z0-9][A-Za-z0-9._\\/\\-]{0,39}" }), name, status],
};
export function fieldsFor(resource, mode) {
  if (mode === "correct") return [attendance, note, reason];
  if (mode === "decision") return [field("status", "Decision", "select", { options: ["approved", "rejected"] }), reason];
  if (mode === "issue") return [employee, reason];
  if (mode === "return") return [reason];
  return resourceFields[resource];
}
export function initialValues(resource, mode, row) {
  return Object.fromEntries(fieldsFor(resource, mode).map((f) => [f.key,
    (mode === "edit" || mode === "correct") && row?.[f.key] != null ? row[f.key] : f.options?.[0] || ""]));
}
// Only send fields in the endpoint DTO. Never spread a server record into JSON.
export function bodyFor(resource, mode, values, row) {
  const body = Object.fromEntries(fieldsFor(resource, mode).map((f) => [f.key,
    f.type === "reference" ? (values[f.key] ? Number(values[f.key]) : null) : values[f.key] || ""]));
  if (mode !== "create") body.revision = row.revision;
  return body;
}